import { useQueryClient, useMutation } from "@tanstack/react-query";
import { archiveProject } from "./useArchiveProject.query";
import { useArchiveProjectProps } from "./useArchiveProject.types";
import { queryKeys } from "../../queryKeys";

export function useArchiveProject() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: queryKeys.project._def,
        mutationFn: async (projectId: useArchiveProjectProps) => {
            const res = await archiveProject(projectId);
            return res;
        },
        onSuccess: ()=> {
            queryClient.invalidateQueries({queryKey: queryKeys.project._def, exact: false});
        }
    });
}
